module.exports = {"closeButtonText":"Tutup","thumbNailAlt":"Pratinjau Gambar","next":"Halaman Selanjutnya","previous":"Halaman Sebelumnya","addNote":"Tambahkan catatan..."}


//////////////////
// WEBPACK FOOTER
// ./translations/id.json
// module id = 33
// module chunks = 0